import React, { useState } from "react";
import { FaYoutube } from "react-icons/fa";
import defaultThumbnail2 from "../assets/thumbnail1.png";

const VideoCard = ({ videoUrl, customThumbnail }) => {
  const [showModal, setShowModal] = useState(false);

  const getYouTubeId = (url) => {
    if (!url) return null;
 
    try {
      const u = url.trim();
     
      const watchMatch = u.match(/[?&]v=([\w-]{11})/);
      if (watchMatch) return watchMatch[1];

      const shortMatch = u.match(/youtu\.be\/([\w-]{11})/);
      if (shortMatch) return shortMatch[1];

      const embedMatch = u.match(/embed\/([\w-]{11})/);
      if (embedMatch) return embedMatch[1];

      const shortsMatch = u.match(/shorts\/([\w-]{11})/);
      if (shortsMatch) return shortsMatch[1];

      
      const last11 = u.split(/[^\w-]/).find((t) => t && t.length === 11);
      return last11 || null;
    } catch (e) {
      return null;
    }
  };

  const videoId = getYouTubeId(videoUrl);

  const defaultThumbnail = videoId
    ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`
    : null;

  
  const buildEmbedUrl = (url) => {
    const id = getYouTubeId(url);
    if (!id) return url; 
    return `https://www.youtube.com/embed/${id}`;
  };

  const embedUrl = buildEmbedUrl(videoUrl);
  
  return (
    <>
      {/* <h1>{customThumbnail}</h1> */}

      <div
        className="video-box"
        style={{ position: "relative", cursor: "pointer" }}
        onClick={() => setShowModal(true)}
      >
   {(customThumbnail==="#" || customThumbnail==null ||customThumbnail==="null")?
        (!videoUrl.includes("youtube")?<img
          src={defaultThumbnail2}
          alt="Video thumbnail"
          style={{ objectFit: "cover" }}
        />:<iframe width="420" title={videoUrl} height="100%"
src={embedUrl}>
</iframe>
):(<img
          src={customThumbnail}
          alt={customThumbnail}
          style={{ objectFit: "cover" }}
        />)}
         
        <button
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            height:"100%",
            width:"100%",
            transform: "translate(-50%, -50%)",
            padding: "20px",
            background: "#00000045",
            color: "#fff",
            border: "none",
           
            fontSize: "20px",
            cursor: "pointer",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            style={{ width: "30%",height:"40%" }}
            src="https://cdn-icons-png.flaticon.com/512/9974/9974136.png"
          />
        </button>
      </div>

      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <button
            onClick={() => setShowModal(false)}
            style={{
              position: "absolute",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              top: 10,
              right: 20,
              background: "gray",
              color: "#fff",
              border: "none",
              borderRadius: "50%",
              width: 40,
              height: 40,
              fontSize: 30,
              cursor: "pointer",
              zIndex: 2,
              fontWeight: "500",
            }}
            aria-label="Close"
          >
            ×
          </button>
          <div
            style={{
              position: "relative",
              background: "#fff",
              padding: 0,
              boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
              maxWidth: "90vw",
              maxHeight: "80vh",
              overflow: "hidden",
            }}
          >
            <iframe
              className="video-box"
              src={`${embedUrl}${embedUrl.includes("?") ? "&" : "?"}autoplay=1`}
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
              title="video"
              style={{ width: "70vw", height: "70vh", display: "block" }}
            ></iframe>
          </div>
        </div>
      )}
    </>
  );
};

export default VideoCard;
